export default {
  async getShoppingLists({ commit }) {
    commit('setIsShoppingListLoading', 'GLOBAL');
    if (this.$auth.isLogged()) {
      try {
        const {
          data: { shoppingLists },
        } = await this.$axios.get(
          `${this.$config.baseOfixApi}/e-commerce/v1/shopping-lists?limit=50`,
          {},
        );
        commit('setShoppingLists', shoppingLists);
      } catch {}
    } else if (!this.defaultShoppingList) {
      try {
        const {
          data: { shoppingList },
        } = await this.$axios.get(
          `${this.$config.baseOfixApi}/e-commerce/v1/shopping-lists/default`,
          {},
        );
        commit('setDefaultList', shoppingList);
      } catch {}
    }
    commit('setIsShoppingListLoading', false);
  },
  async toggleProductFromList({ dispatch, state, commit }, { product, isOnList, products }) {
    if (state.isLoading) return;
    if (this.$auth.isLogged()) {
      await commit(
        'modal/pushModal',
        {
          modal: {
            name: 'addProductToList',
            path: 'Lists/ModalAddProductToList',
            title: 'Dodaj do listy zakupowej',
            theme: 'Lite',
            buttons: [
              {
                action: 'openNewListModal',
                text: 'Nowa lista',
                theme: 'lightPurple',
                space: 'right',
              },
              { action: 'closeModal', text: 'Gotowe', theme: 'purple', space: 'left' },
            ],
          },
          data: { product, products },
        },
        { root: true },
      );
    } else if (isOnList) {
      await dispatch('deleteProductFromDefaultList', product);
    } else {
      await dispatch('addProductToDefaultList', product);
    }
  },
  async addProductToDefaultList({ commit, dispatch }, item) {
    commit('setIsShoppingListLoading', 'DEFAULT');
    const {
      data: { shoppingList },
    } = await this.$axios.post(
      `${this.$config.baseOfixApi}/e-commerce/v1/shopping-lists/default?itemId=${
        item.id
      }&quantity=${1}`,
    );
    await commit('setDefaultList', shoppingList);
    commit('setIsShoppingListLoading', false);
    await dispatch('gtmAddToShoppingList', item);
  },
  async deleteProductFromDefaultList({ commit, dispatch }, item) {
    commit('setIsShoppingListLoading', 'DEFAULT');
    const {
      data: { shoppingList },
    } = await this.$axios.delete(
      `${this.$config.baseOfixApi}/e-commerce/v1/shopping-lists/default?itemIds=${item.id}`,
      {
        itemIds: [item.id],
      },
    );
    commit('setDefaultList', shoppingList);
    commit('setIsShoppingListLoading', false);
    await dispatch('deleteProductToast', item);
    await dispatch('gtmRemoveFromShoppingList', item);
  },
  async addProductToShoppingList({ store, commit, dispatch }, { product, shoppingListId }) {
    commit('setIsShoppingListLoading', shoppingListId);
    const {
      data: { shoppingList },
    } = await this.$axios.put(
      `${this.$config.baseOfixApi}/e-commerce/v1/shopping-lists/${shoppingListId}/items`,
      {
        itemId: product.id,
        quantity: 1,
      },
    );
    commit('updateItemInList', shoppingList);
    commit('setIsShoppingListLoading', false);
    await dispatch('gtmAddToShoppingList', product);
  },
  async addProductsToShoppingList({ store, commit, dispatch }, { products, shoppingListId }) {
    commit('setIsShoppingListLoading', shoppingListId);
    const {
      data: { shoppingList },
    } = await this.$axios.post(
      `${this.$config.baseOfixApi}/e-commerce/v1/shopping-lists/${shoppingListId}/items`,
      {
        items: products,
      },
    );
    commit('updateItemInList', shoppingList);
    commit('setIsShoppingListLoading', false);
  },
  async deleteProductFromShoppingList({ commit, dispatch }, { product, shoppingListId }) {
    commit('setIsShoppingListLoading', shoppingListId);
    const {
      data: { shoppingList },
    } = await this.$axios.delete(
      `${this.$config.baseOfixApi}/e-commerce/v1/shopping-lists/${shoppingListId}/items/${product.id}`,
    );
    commit('updateItemInList', shoppingList);
    commit('setIsShoppingListLoading', false);
    await dispatch('gtmRemoveFromShoppingList', product);
    return shoppingList;
  },
  async deleteProductsFromShoppingList({ commit, dispatch }, { products, shoppingListId }) {
    const {
      data: { shoppingList },
    } = await this.$axios.delete(
      `${this.$config.baseOfixApi}/e-commerce/v1/shopping-lists/${shoppingListId}/items?itemIds=${products}`,
    );
    commit('updateItemInList', shoppingList);

    return shoppingList;
  },
  async deleteShoppingList({ commit, state }, { id }) {
    try {
      await this.$axios.delete(
        `${this.$config.baseOfixApi}/e-commerce/v1/shopping-lists/${id}`,
        {},
      );
      const shoppingLists = state.shoppingLists;
      commit(
        'setShoppingLists',
        shoppingLists.filter(list => list.id !== id),
      );
    } catch (e) {
      const message = e?.response?.data?.message || 'Wystąpił błąd podczas usuwania listy';

      this.$toast.error(`<div class="popupToast__content">${message}</div>`, {
        theme: 'popupToast__inner',
        containerClass: 'popupToast__container',
        keepOnHover: true,
        duration: 4000,
        action: [
          {
            class: 'popupToast__close',
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            },
          },
        ],
      });
    }
  },
  async addShoppingListToBasket({ commit, rootState, dispatch }, { id, items }) {
    try {
      const { data } = await this.$axios.post(
        `${this.$config.baseOfixApi}/e-commerce/v1/shopping-lists/${id}/add-to-shopping-cart`,
        { items },
      );

      commit('cart/setCart', data.shoppingCart, { root: true });
      this.$toast.success(`<div class="popupToast__content" >${data.message}</div>`, {
        theme: 'popupToast__inner',
        containerClass: 'popupToast__container',
        keepOnHover: true,
        duration: 4000,
        action: [
          {
            text: 'Zobacz',
            onClick: (e, toastObject) => {
              this.$router.push(this.localePath({ name: 'cart' }));
              toastObject.goAway(0);
            },
          },
          {
            class: 'popupToast__close',
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            },
          },
        ],
      });
    } catch (e) {
      const message =
        e?.response?.data?.message || 'Wystąpił błąd podczas dodawania listy do koszyka';

      this.$toast.error(`<div class="popupToast__content">${message}</div>`, {
        theme: 'popupToast__inner',
        containerClass: 'popupToast__container',
        keepOnHover: true,
        duration: 4000,
        action: [
          {
            class: 'popupToast__close',
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            },
          },
        ],
      });
    }
  },
  async addNewShoppingList({ commit, state }, formFields) {
    let formData = {
      type: formFields.type ? formFields.type : 'on_demand',
      name: formFields.name,
    };

    if (formFields.reminderAgreement) {
      formData = {
        type: formFields.type ? formFields.type : 'on_demand',
        name: formFields.name,
        startDate: formFields.startDate,
        reminderAgreement: formFields.reminderAgreement,
        cycleType: formFields.cycleType,
        cycleStep: formFields.cycleStep ? formFields.cycleStep : null,
      };
    }
    const {
      data: { shoppingList },
    } = await this.$axios.post(
      `${this.$config.baseOfixApi}/e-commerce/v1/shopping-lists`,
      formData,
    );
    const shoppingLists = [...state.shoppingLists];
    shoppingLists.push(shoppingList);
    commit('setShoppingLists', shoppingLists);
    await commit('modal/popModal', {}, { root: true });
  },
  async updateNewShoppingList({ commit, state }, { formFields, id }) {
    let formData = {
      type: formFields.type && formFields.reminderAgreement ? formFields.type : 'on_demand',
      name: formFields.name,
      reminderAgreement: formFields.reminderAgreement,
    };

    if (formFields.reminderAgreement) {
      formData = {
        type: formFields.type ? formFields.type : 'on_demand',
        name: formFields.name,
        startDate: formFields.startDate,
        reminderAgreement: formFields.reminderAgreement,
        cycleType: formFields.cycleType,
        cycleStep: formFields.cycleStep ? formFields.cycleStep : null,
      };
    }
    const { data } = await this.$axios.put(
      `${this.$config.baseOfixApi}/e-commerce/v1/shopping-lists/${id}`,
      formData,
    );
    await commit('modal/popModal', {}, { root: true });

    return data;
  },
  gtmRemoveFromShoppingList(store, item) {
    const categories = item?.category?.namesInPath.reduce((acc, curr, index) => {
      acc['category' + (index === 0 ? '' : index + 1)] = curr;
      return acc;
    }, {});

    this.$gtm.push({ ecommerce: null });
    this.$gtm.push({
      event: 'remove_from_wishlist',
      ecommerce: {
        item_list_id: '',
        item_list_name: '',
        items: [
          {
            item_id: item.id,
            item_name: item.name,
            discount: item.priceBeforeDiscountObject
              ? this.$helper.calculateDiscount(
                  item.priceBeforeDiscountObject.gross,
                  item.priceObject.gross,
                )
              : 0,
            brand: item.brand ? item.brand.name : '',
            ...categories,
            item_list_id: '',
            item_list_name: '',
            price: item.priceObject.gross,
            variant: '',
            quantity: 1,
          },
        ],
      },
    });
  },
  gtmAddToShoppingList(store, item) {
    const categories = item?.category?.namesInPath.reduce((acc, curr, index) => {
      acc['category' + (index === 0 ? '' : index + 1)] = curr;
      return acc;
    }, {});

    this.$gtm.push({ ecommerce: null });
    this.$gtm.push({
      event: 'add_to_wishlist',
      ecommerce: {
        item_list_id: '',
        item_list_name: '',
        items: [
          {
            item_id: item.id,
            item_name: item.name,
            discount: item.priceBeforeDiscountObject
              ? this.$helper.calculateDiscount(
                  item.priceBeforeDiscountObject.gross,
                  item.priceObject.gross,
                )
              : 0,
            brand: item.brand ? item.brand.name : '',
            ...categories,
            item_list_id: '',
            item_list_name: '',
            price: item.priceObject.gross,
            variant: '',
            quantity: 1,
          },
        ],
      },
    });
  },
  deleteProductsToast(store) {
    this.$toast.success(`<div class="popupToast__content">Produkty Zostay usunięte z listy</div>`, {
      theme: 'popupToast__inner',
      containerClass: 'popupToast__container',
      keepOnHover: true,
      duration: 4000,
      action: [
        {
          class: 'popupToast__close',
          onClick: (e, toastObject) => {
            toastObject.goAway(0);
          },
        },
      ],
    });
  },
  deleteProductToast(store, product) {
    this.$toast.success(
      `<div class="popupToast__content"><b>${this.$helper.shortText(
        product.name,
        40,
      )}</b><br />Został usunięty z listy</div>`,
      {
        theme: 'popupToast__inner',
        containerClass: 'popupToast__container',
        keepOnHover: true,
        duration: 4000,
        action: [
          {
            class: 'popupToast__close',
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            },
          },
        ],
      },
    );
  },
  addProductToast(store, product) {
    this.$toast.success(
      `<div class="popupToast__content"><b>${this.$helper.shortText(
        product.name,
        40,
      )}</b><br />Został dodany do listy</div>`,
      {
        theme: 'popupToast__inner',
        containerClass: 'popupToast__container',
        keepOnHover: true,
        duration: 4000,
        action: [
          {
            text: 'Zobacz',
            onClick: (e, toastObject) => {
              this.$router.push(this.localePath({ name: 'shoppingList' }));
              toastObject.goAway(0);
            },
          },
          {
            class: 'popupToast__close',
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            },
          },
        ],
      },
    );
  },
  async openNewListModal({ commit }, formFields) {
    await commit(
      'modal/pushModal',
      {
        modal: {
          name: 'addNewList',
          path: 'Lists/ModalAddNewList',
          title: 'Dodaj listę zakupową',
          theme: 'Lite',
          buttons: [
            { action: 'saveModalAddNewList', text: 'Zatwierdź', theme: 'purple', space: 'left' },
          ],
        },
        data: { formFields },
      },
      { root: true },
    );
  },
  async openModalAddShoppingListToBasket({ commit, rootState, dispatch }, { id }) {
    if (rootState.cart.shoppingCart.items && rootState.cart.shoppingCart.items.length) {
      await commit(
        'modal/pushModal',
        {
          modal: {
            name: 'addNewList',
            path: 'Lists/ModalAddShoppingListToBasket',
            title: 'Czy chcesz wyczyścić koszyk?',
            buttons: [
              {
                action: 'addToBasket',
                text: 'Nie, pozostaw produkty',
                theme: 'lightPurple',
                space: 'left',
              },
              {
                action: 'clearBasket',
                text: 'Tak, wyczyść koszyk',
                theme: 'purple',
                space: 'left',
              },
            ],
          },
          data: { id },
        },
        { root: true },
      );
    } else {
      dispatch('addShoppingListToBasket', { id });
    }
  },
  async getShoppingListsTypes({ state, commit }) {
    if (state.shoppingListsTypes?.length) return;
    const {
      data: { shoppingListTypes },
    } = await this.$axios.get(`${this.$config.baseOfixApi}/e-commerce/v1/shopping-lists/types`);
    commit('setShoppingListsTypes', shoppingListTypes);
  },
  async getShoppingListsCycles({ state, commit }) {
    if (state.shoppingListCycles?.length) return;
    const {
      data: { shoppingListCycles },
    } = await this.$axios.get(`${this.$config.baseOfixApi}/e-commerce/v1/shopping-lists/cycles`);
    commit('setShoppingListCycles', shoppingListCycles);
  },
};
